import React, { useEffect } from 'react';
import './AboutSection.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useLanguage } from '../hooks/useLanguage';

const AboutSection = () => {
  const { t } = useLanguage();

  useEffect(() => {
    AOS.init({ duration: 900, once: false });
  }, []);

  return (
    <section className="about" id="about" data-aos="fade-right">
      <div className="about-content">
        <h2 className="section-heading" data-aos="fade-left">{t.nav.about}</h2>
        <p data-aos="zoom-in" data-aos-delay="100">{t.about.p1}</p>
        <p data-aos="fade-up" data-aos-delay="200">{t.about.p2}</p>
        <p data-aos="fade-up" data-aos-delay="300">{t.about.p3}</p>
      </div>
    </section>
  );
};

export default AboutSection;
